// this is referenced from .cs
export enum DocumentItemType {
    None = 0,
    Error = 1,
    Loading = 2,
    File = 10,
    Image = 11,
}
